

export function formatMinute(minutes) {
    return String(parseInt(minutes || 0)).padStart(2, 0);
};
export function formatHeureMinute(minutes) {
    return String(Math.floor(parseInt(minutes) / 60 || 0)) + "h" + String(parseInt(minutes % 60 || 0)).padStart(2, 0);
};
export function formatTime(heures, minutes) {
    return String(parseInt(heures || 0)).padStart(2, 0) + ":" + String(parseInt(minutes % 60 || 0)).padStart(2, 0);
};
